import { combineReducers } from 'redux';
import userRole from './userRoleReducer';

const userReducers = combineReducers({
  role: userRole,
});

export default userReducers;
